// extracted by mini-css-extract-plugin
module.exports = {"cardMargin":"gpStyles_cardMargin__Juxt-"};